'use client'

import type { ChangeEvent } from 'react'
import React, { useState } from 'react'
import { useLocalisation } from '../../client'
import styles from './LanguageSelector.module.scss'
import type { Language } from '@/tools/i18n'
import { languages } from '@/tools/i18n'
import { useErrorHandling } from '@/tools/o11y/client'

export const LanguageSelector: React.FC = () => {
  const { getLanguage, loadLanguageAndRefresh } = useLocalisation()
  const [selectedLanguage, setSelectedLanguage] = useState<string>(getLanguage())
  const { withErrorTracking } = useErrorHandling()

  const handleChange = withErrorTracking(async (event: ChangeEvent<HTMLSelectElement>) => {
    const language = event.target.value as Language
    setSelectedLanguage(language)
    await loadLanguageAndRefresh(language)
  })

  return (
    <div className={styles.container}>
      <select className={styles.item} value={selectedLanguage} onChange={handleChange}>
        {languages.map((option, index) => (
          <option key={index} value={option.code}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  )
}
